import { render } from "./CameraScan.vue?vue&type=template&id=7b9e381d&scoped=true"
import script from "./CameraScan.vue?vue&type=script&lang=js"
export * from "./CameraScan.vue?vue&type=script&lang=js"

import "./CameraScan.vue?vue&type=style&index=0&id=7b9e381d&scoped=true&lang=css"

import exportComponent from "/Users/zwl/Desktop/work/DEV/wms-phone/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b9e381d"]])

export default __exports__